import React from 'react';
import { Provider } from 'react-redux';

import Notify from './Notify';

export default function Notification(props){
	return (
		<Provider store={props.store}>
			<Notify />
		</Provider>
	);
}
